import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@library-shared/base/base.component';
import { spSite_Client_By_DomainX } from '@models/StoredProcs-Extended/spSite_Client_By_DomainX';
import { spSite_Affirmation_By_Site_ID } from '@models/StoredProcs/spSite_Affirmation_By_Site_ID';
import { SiteService } from '@services/site/site.service';

@Component({
  selector: 'app-affirmation',
  templateUrl: './affirmation.component.html',
  styleUrls: ['./affirmation.component.scss'],
  standalone: false,
})
export class AffirmationComponent extends BaseComponent implements OnInit, AfterViewInit {
  @ViewChild('affirmationContainer') container: ElementRef;

  affirmationIndex = 0;
  siteInfo: spSite_Client_By_DomainX;
  affirmation: spSite_Affirmation_By_Site_ID;
  affirmed = false;

  constructor(
    private siteService: SiteService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.loadData();
  }

  get boxHeight(): any {
    return { height: `${this.viewportHeight - 240}px` };
  }

  get textHeight(): any {
    return { height: `${this.viewportHeight - 370}px` };
  }

  loadData() {
    this.isLoading2.set(true);
    this.siteService.Site_Info().subscribe({
      next: (data) => {
        this.siteInfo = data.record;
        this.loadAffirmation();
        this.isLoading2.set(false);
      },
    });
  }

  loadAffirmation() {
    this.affirmation = this.siteInfo.Site_Affirmation_List[this.affirmationIndex];
  }

  back() {
    this.router.navigateByUrl('/ticketselect');
  }

  next() {
    if (this.affirmationIndex < this.siteInfo.Site_Affirmation_List.length - 1) {
      this.isLoading2.set(true);
      this.affirmed = false;
      this.affirmationIndex++;
      this.loadAffirmation();
      this.isLoading2.set(false);
    } else {
      this.router.navigateByUrl('/payment');
    }
  }
}
